import React from 'react';
import {Select} from "antd";

const FaceLibraryImport = () => {
    return (
        <div className="main-padding video-parameteres">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>List Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>Face Library Import</span>
            </div>
            <div className="camera-config-content">
                <h6 className="alert-title-cmcf">
                    Image naming rules: Name_ID.jpg, name and ID cannot be longer than 32 bytes ! The resolution of registered images should not exceed 1080x1920 !
                </h6>
                <div className="row mt-5">
                    <div className="col-md-6 d-flex">
                        <input type="file" className="form-control"/>
                        <button className="btn btn-success ml-24">
                            Upload To Device
                        </button>
                    </div>
                    <div className="col-md-6">
                        <div className="row   align-items-center">
                            <div className="col-md-4 text-end">
                                <label  className="text-white">
                                    Default User Group
                                </label>
                            </div>
                            <div className="col-md-4">
                                <Select

                                    placeholder="Поиск, чтобы выбрать"
                                    optionFilterProp="children"
                                    className="w-100"

                                >
                                    <option value="1">asd</option>
                                    <option value="3">asd</option>
                                    <option value="2">asd</option>
                                </Select>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default FaceLibraryImport;